module.exports = __webpack_public_path__ + "46f0a3ad815962005753c02c4181aadc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ubuntu_Mono/UbuntuMono-Bold.ttf
// module id = 373
// module chunks = 0